module.exports = __webpack_public_path__ + "img/car_00026.0abe2210.jpg";